import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";
import {
  PAYMENT_DELETE,
  PAYMENT_LIST,
  PAYMENT_DETAILS,
} from "../actions/payment.actions.types";

const call = Effects.call;

function* getPaymentList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "payments/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* getPaymentDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `payments/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* deletePayment({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `payments/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* Payment() {
  yield all([
    takeLatest(PAYMENT_LIST, getPaymentList),
    takeLatest(PAYMENT_DETAILS, getPaymentDetails),
    takeLatest(PAYMENT_DELETE, deletePayment),
  ]);
}

export default Payment;
